import { useState } from 'react';

import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useBooleanOptions } from './useBooleanOptions';
import { ValidatedSingleStringValueInputProps } from '../types';

export const BooleanSelect = ({
  onChange,
  value,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
}: ValidatedSingleStringValueInputProps) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const options = useBooleanOptions({ search });
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueSingleStringSelect: VisualComponent } = useVisualComponentsContext();

  return (
    <VisualComponent
      comparator={comparator}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      hasError={!!isInvalid}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      isDisabled={!!isReadOnly}
      search={search}
      setSearch={setSearch}
      onChange={onChange}
      options={options}
      value={value}
      placeholder={t('v2.conditionBuilder.singleBooleanPlaceholder')}
    />
  );
};
